import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Gift, Headphones, Calendar, BookOpen, Target, Zap } from 'lucide-react';
export function BonusesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bonuses = [{
    icon: Headphones,
    title: 'Guía: "Qué Hacer Si Te Estancas"',
    desc: 'Para cuando sentís que no avanzás y estás por abandonar',
    value: '$14.999'
  }, {
    icon: Calendar,
    title: 'Planificador Semanal',
    desc: 'Organizá tus sesiones y seguí tu progreso',
    value: '$14.999'
  }, {
    icon: Gift,
    title: 'Guía Anti-Abandono',
    desc: 'Técnicas para recuperarte más rápido',
    value: '$14.999'
  }, {
    icon: BookOpen,
    title: 'Manual de Mentalidad Ganadora',
    desc: 'Reprogramá tu mente para el éxito y la constancia',
    value: '$14.999'
  }, {
    icon: Target,
    title: 'Plantilla de Objetivos SMART',
    desc: 'Definí metas claras y alcanzables paso a paso',
    value: '$14.999'
  }, {
    icon: Zap,
    title: 'Rutinas Express de 15 Minutos',
    desc: 'Para los días que no tenés tiempo pero no querés perder el ritmo',
    value: '$14.999'
  }];
  return <section ref={ref} className="py-20 px-4 bg-navy" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <motion.h2 className="text-4xl md:text-5xl font-black mb-4 text-center" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-25">
          Además, HOY te llevás <span className="text-accent" data-id="element-26">GRATIS</span>
        </motion.h2>

        <motion.p className="text-xl text-gray-300 text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-27">
          6 BONOS EXCLUSIVOS
        </motion.p>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-28">
          {bonuses.map((bonus, i) => <motion.div key={i} className="bg-navy-light p-8 rounded-2xl border-2 border-accent/30 relative overflow-hidden" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3 + i * 0.1
        }} whileHover={{
          scale: 1.05
        }} data-id="element-29">
              {/* FREE badge */}
              <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-30">
                GRATIS
              </div>
              <div className="bg-accent/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-31">
                <bonus.icon className="text-accent" size={32} data-id="element-32" />
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-33">{bonus.title}</h3>
              <p className="text-gray-300 mb-4" data-id="element-34">{bonus.desc}</p>
              <div className="flex items-center gap-2" data-id="element-35">
                <span className="text-gray-500 line-through text-lg" data-id="element-36">
                  Valor: {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}